import { createPartlistApi } from "@org-avp/avp-avengers-partlist-service-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const baseQueryArgs: Parameters<typeof fetchBaseQuery>[0] = {
  baseUrl: environment.NX_PROJECT_SERVICE_BASE_URL,
  prepareHeaders,
};

export const partlistApi: ReturnType<typeof createPartlistApi> = createPartlistApi({
  baseQueryArgs,
});
